import React, { useContext } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { PageSubtitle, Button, TextButton } from '../../atoms'
import { SubtitleWithLink, ProfileItem } from '../../molecules'

import { mediaPc } from '../../../lib/MediaQuery'
import { useBusinessUserLogout } from '../../../lib/Logout'

import { BusinessUserProfileContext } from '../../../context'

type Props = {
  isVisibleEditButton?: boolean
}

const Wrapper = styled.div`
  margin-bottom: 8.5vw;
  .title {
    margin-bottom: 2vw;
  }
  .data {
    padding: 5vw 5vw 7vw;
    background: ${(props): string => props.theme.backgroundColors.bodyBg};
    border-radius: 4px;
    dd {
      margin-bottom: 3vw;
    }
    .edit {
      line-height: 2.4;
    }
  }
  ${mediaPc`
    width: 240px;
    margin-bottom: 0;
    padding: 0;
    .title {
      margin-bottom: 20px;
      .subtitle-text {
        font-size: 14px;
      }
    }
    .data {
      padding: 25px 20px;
      dd {
        margin-bottom: 15px;
        font-size: 14px;
        border: none;
      }
      .edit {
        margin-bottom: 80px;
        font-size: 12px;
        line-height: 30px;
      }
      .logout {
        width: 50%;
        margin: 0 auto;
        font-weight: bold;
      }
    }
  `}
`

export const BusinessProfile: React.FC<Props> = ({ isVisibleEditButton = true }) => {
  const history = useHistory()
  const businessUserProfile = useContext(BusinessUserProfileContext)

  const goToEdit = (): void => {
    history.push('/business/mypage/edit')
  }

  return (
    <Wrapper>
      <div className="sp title">
        <SubtitleWithLink subtitle="アカウント情報" linkText="ログアウト" onClick={useBusinessUserLogout()} />
      </div>
      <div className="pc title">
        <PageSubtitle subtitle="アカウント情報" className="subtitle-text" />
      </div>

      <div className="data">
        <dl>
          <ProfileItem className="business-profile" label="ビジネスアカウント">
            {businessUserProfile.businessName}
          </ProfileItem>
          <ProfileItem className="business-profile" label="メールアドレス">
            {businessUserProfile.businessEmail}
          </ProfileItem>
        </dl>
        {isVisibleEditButton && (
          <Button buttonType="white" onClick={goToEdit} className="edit">
            編集
          </Button>
        )}
        <TextButton onClick={useBusinessUserLogout()} className="pc logout">
          ログアウト
        </TextButton>
      </div>
    </Wrapper>
  )
}
